export default `@charset "UTF-8";
/* Ids Loading Indicator */
:host(ids-loading-indicator:not([linear]):not([sticky])) {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

:host(ids-loading-indicator:not([linear]):not([sticky]):not([inline])) {
  width: 50px;
  height: 50px;
}

:host(ids-loading-indicator[inline]:not([linear]):not([sticky])) {
  width: 11px;
  height: 11px;
}

:host(ids-loading-indicator[align=center]:not([linear]):not([sticky]):not([inline])) {
  position: fixed;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  margin-block-start: -25px;
}

:host(ids-loading-indicator[align=center]:not([stopped])[contained]:not([sticky]):not([inline])) {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

:host(ids-loading-indicator[stopped]:not([linear]):not([sticky])),
:host(ids-loading-indicator[stopped][linear]),
:host(ids-loading-indicator[stopped][sticky]) {
  display: none;
}

:host(ids-loading-indicator[linear]),
:host(ids-loading-indicator[sticky]) {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

:host(ids-loading-indicator[sticky]) {
  position: absolute;
  align-items: center;
  top: 0;
  left: 0;
}

:host(ids-loading-indicator[linear]) {
  align-items: flex-end;
  height: 48px;
}

:host(ids-loading-indicator[overlay]) {
  z-index: var(--ids-z-index-top-level-container);
}

.progress {
  transition: stroke-dashoffset 0.275s ease-in, transform 0.275s ease-in;
  z-index: 1;
}

.progress-percentage {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 49%;
  transform: translate(-50%, -50%);
  color: var(--ids-loading-indicator-color-text);
}

.progress-percentage.linear {
  top: 50%;
}

.percentage {
  position: relative;
  top: -4px;
  right: -2px;
}

svg.linear-indicator {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--ids-loading-indicator-height);
  overflow: hidden;
}
svg.linear-indicator.sticky {
  height: var(--ids-loading-indicator-height);
}
svg.linear-indicator .progress {
  fill: var(--ids-loading-indicator-progress-color, transparent);
  transform: scaleX(calc(var(--progress) * 1%));
}
svg.linear-indicator .circle {
  fill: var(--ids-loading-indicator-circle-color, transparent);
}

svg.circular-indicator {
  position: relative;
  overflow: visible;
  fill: var(--ids-color-transparent, transparent);
  transform-origin: 50% 50%;
  transform: rotateZ(-90deg);
  display: flex;
  align-items: center;
  justify-content: center;
}
svg.circular-indicator circle {
  transform-origin: 50% 50%;
}
svg.circular-indicator .circle {
  stroke: var(--ids-loading-indicator-circle-color, transparent);
}
svg.circular-indicator .progress {
  stroke-dasharray: 283;
  stroke: var(--ids-loading-indicator-progress-color, transparent);
}

svg.circular-indicator:not(.inline) {
  width: 50px;
  height: 50px;
}

svg.circular-indicator.inline {
  width: 11px;
  height: 11px;
}

.circular-indicator.determinate .progress {
  /*
   * circumference is 2πr(45) => 282.74, or 283
   */
  stroke-dashoffset: calc(283px - (var(--progress) * 2.83));
}

.ai-loading-indicator {
  display: flex;
  position: relative;
  width: 56px;
}

.ai-loading-indicator .bar {
  margin-right: 2px;
  margin-left: 2px;
  background-color: var(--ids-loading-indicator-ai-color-background-default, transparent);
  width: 16px;
  height: 8px;
  border-radius: 8px;
  transition: 0.2s;
  animation: loading 1.2s ease-in-out 0.2s infinite;
}

.ai-loading-indicator .bar:nth-child(1) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-one, transparent);
  animation-delay: 0s;
}

.ai-loading-indicator .bar:nth-child(2) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-two, transparent);
  animation-delay: 0.14s;
}

.ai-loading-indicator .bar:nth-child(3) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-three, transparent);
  animation-delay: 0.42s;
}

@keyframes indeterminate-spinner-progress-anim {
  0%, 15% {
    stroke-dashoffset: 272;
    transform: rotate(0);
  }
  60% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  65% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 272;
    transform: rotate(360deg);
  }
}
@keyframes indeterminate-spinner-anim {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
svg.circular-indicator.indeterminate .progress {
  animation: 1.52s linear infinite both indeterminate-spinner-progress-anim;
}

svg.circular-indicator.indeterminate {
  animation: 2.4s linear infinite indeterminate-spinner-anim;
}

svg.linear-indicator.indeterminate .progress {
  animation: 2.8s linear infinite both indeterminate-linear-progress-anim;
}

@keyframes indeterminate-linear-progress-anim {
  0% {
    transform: translateX(0%) scaleX(0.0001);
  }
  3.125%, 53.125% {
    transform: translateX(0%) scaleX(0.2);
  }
  6.25% {
    transform: translateX(20%) scaleX(0.3);
  }
  12.5%, 62.5% {
    transform: translateX(60%) scaleX(0.45);
  }
  25%, 75% {
    transform: translateX(100%) scaleX(1);
  }
  25.0001%, 50%, 75.0001%, 100% {
    transform: translateX(0%) scaleX(0.0001);
  }
}
@keyframes loading {
  0% {
    height: 8px;
  }
  50% {
    width: 56px;
  }
  100% {
    height: 8px;
  }
}
:host([size=xs]:not([linear]):not([sticky]):not([inline])), :host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(container) {
  width: 15px;
  height: 15px;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(circle) {
  stroke-width: 12;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(progress) {
  stroke-width: 21;
}

:host(.type-primary)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-circle-stroke, transparent);
}
:host(.type-primary)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-progress-color-border, transparent);
}

:host(.type-primary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-destructive-progress-color-border, transparent);
}
:host(.type-primary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-destructive-circle-stroke, transparent);
}

:host(.type-tertiary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-destructive-progress-color-border, transparent);
}
:host(.type-tertiary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-tertiary-destructive-circle-stroke, transparent);
}

ids-loading-indicator[contained][overlay] {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.loading-container {
  position: relative;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
